module.exports = __webpack_public_path__ + "static/media/portrait_pitbull.4d9b9e58.jpeg";